import Hand from 'play_perfect/Hand'

class Game {

  constructor(wasm, _game, options = {}) {
    this.config = options
    this.game = _game
    this.wasm = wasm

    this.handNum = 0
    this.bet = options.bet || 5
    this.credits = options.credits || 0
    this.noCard = options.noCard || "c400"

    this.handSize = options.numCards || 5
    this.hand = new Hand(this.handSize, this.noCard)
    this.hand.set(options.hand || [])

    this.deck = []
    this.deckSize = this.handSize * 2 // bad var name

    this.handLastEvaluated
    this.held = options.held || this.noCardsHeld()

    this.numCardsSelected = 0
    this.dealtHand = []
    this.dealtHandValue
    this.finalHandValue
    this.evs
    this.state = null
  }

  noCardsHeld() {
    return [0, 0, 0, 0, 0]
  }

  ready() {
    return this.wasm && this.wasm.status() == 1
  }
/*
  changeGame(_game) {
    if (this.wasm) this.wasm.freeMemory()
    this.game = _game
    this.wasm = WASM(_game);
  }
*/
  setDeck(){
    this.deck = CardUtil.deck(this.deckSize, 52).map(cardNum => CardUtil.cNum2Card(cardNum)); // ["c400", "c102", ....
  }

  deal() {
    this.state = 'deal'
    this.held = this.noCardsHeld()
    this.handNum += 1
    this.credits = this.credits - this.bet
    this.setDeck()
    for (var i = 0; i < this.handSize; i++) {
      this.dealtHand[i] = this.deck.pop()
    }
    this.hand = this.dealtHand.slice(0)
    this.dealtHandValue = this.wasm.getResult(this.hand);
  }

  toggleHeld(n) {
    this.held[n] = !this.held[n]
    return this.held[n]
  }

  clearHand() {
    this.numCardsSelected = 0;
    for (var i = 0; i < this.handSize; i++) {
      this.hand[i] = this.noCard
    }
  }

  setHand(_hand){
    this.hand.set(_hand)
    this.numCardsSelected = this.hand.num_not_noCard()
  }

  cardInHand(card) {
    const j = this.hand.indexOf(card)
    return (j >= 0)
  }

  removeCardFromHand(card) {
    this.numCardsSelected -= this.hand.removeCard(card)
    return this.numCardsSelected
  }

  addCardToHand(card) {
    if (this.numCardsSelected < this.handSize) this.numCardsSelected += this.hand.addCard(card)
    return this.numCardsSelected
  }

  perfectPlay(hand) {
    if (hand) this.hand = hand;
    this.getEVs();
    debug.log("game.perfectPlay", this.evs);
  }

  getEVs(force = false) {
    this.evs = this.wasm.getEVs(this.hand);
    this.handLastEvaluated = Array.from(this.hand); // copy
  }

  bestHold() {
    const bev = this.bestEV();
    return bev ? bev.holdBitCodeL2R : null
  }

  bestEV() {
    return (this.evs || [])[0]
  }

  replaceCard(h, i) {
    if (!h) this.hand[i] = this.deck.pop(); // 0 or false
  }

  draw() {
    this.state = 'draw';
    // this does perfect play
    //  this.bestHold().map( (h,i) => this.replaceCard(h,i ) )  // has to be arrow function
    // this does user play
    this.held.map((h, i) => this.replaceCard(h, i))  // has to be arrow function
    this.finalHand = this.hand.slice(0);
    this.finalHandValue = this.wasm.getResult(this.hand);
    this.win = this.finalHandValue.payout;
    this.credits += this.win;
  }

  error() {
    debug.log("error?")
    const bestHoldA = this.bestHold()
    debug.log('bestHoldA', bestHoldA)
    //  if ( !bestHoldA ) return false;

    let i;
    for (i = 0; i < this.held.length; i++) {
      debug.log(this.held[i], bestHoldA[i])
      if (this.held[i] != bestHoldA[i]) return true;
    }
    return false
  }

}

export default Game